// ADVENT 2026 — PDP SCRIPTS

$(function(){

    setup_swipers()

    // SPOILERS: unblur the lineup for people who hate surprises
    $(".reveal-spoilers").click(function(){
        $(this).text("Naughty List!")
        setTimeout(function(){
            $(".spoilers").addClass("revealed")
        }, 350)
    })

    // Fade in the hero title/button once the page has settled
    setTimeout(function(){
        $(".hero .text").addClass("active")
        $(".hero .blinds-text").addClass("visible")
    }, 800)

    setup_puzzle()
    setup_pixel_images()
    setup_coffee_video()
    setup_sticky_atc()
    setup_deeplinks()

})


// Puzzle + gameboy are one sticky sequence, all driven by scrolltied.
// Custom offset math was racing the library and drifting when the coffee
// images above this section lazy-loaded and pushed the puzzle down.
function setup_puzzle(){

    var puzzle_section = document.querySelector(".puzzle")
    if (!puzzle_section) return

    window.scrolltied = new ScrollTide({ nomarkers: true })

    setup_puzzle_video(puzzle_section)
    setup_puzzle_slider(puzzle_section)
    setup_gameboy_shrink(puzzle_section)
    setup_game_stage(puzzle_section)

    scrolltied.start()
    bind_puzzle_layout_refresh(puzzle_section)
    refresh_puzzle()

}


// Use the element's document Y (not offsetTop, which is offsetParent-relative)
// so trigger points stay correct even if a wrapper is positioned.
function document_top(el){
    var rect = el.getBoundingClientRect()
    return rect.top + (window.scrollY || window.pageYOffset || 0)
}

function pin_scroller_to_document(scroller){
    var recache = scroller.recache.bind(scroller)
    scroller.recache = function(){
        recache()
        this.cache.el.offsetTop = document_top(this.container)
        this.cache.el.scrollHeight = this.container.scrollHeight
    }
}

function add_pinned_scroller(opts){
    var scroller = new Scroller(opts)
    pin_scroller_to_document(scroller)
    scrolltied.add(scroller)
    return scroller
}

function refresh_puzzle(){
    sync_puzzle_mobile_span()
    if (window.scrolltied) scrolltied.update()
}

// Mobile: the first copy beat is 100vh and the other two are 40vh, so the
// section is shorter than desktop's 360vh of copy. Scale the puzzle scroll
// fractions so the video and shrink still land in the unchanged lead-in.
function sync_puzzle_mobile_span(){
    if (!window.scrolltied) return

    var puzzle = document.querySelector(".puzzle")
    if (!puzzle) return

    var desktop = 360 / 0.53
    var mobile = (360 * 0.47 / 0.53) + 180
    var scale = window.matchMedia("(max-width: 800px)").matches ? desktop / mobile : 1

    scrolltied.scrollers.forEach(function(scroller){
        if (!scroller || scroller.container !== puzzle) return
        if (scroller._base_start == null) {
            scroller._base_start = scroller.el_start
            scroller._base_end = scroller.el_end
        }
        scroller.el_start = scroller._base_start * scale
        scroller.el_end = scroller._base_end * scale
    })
}

function bind_puzzle_layout_refresh(puzzle_section){

    window.addEventListener("load", refresh_puzzle)
    window.addEventListener("pageshow", refresh_puzzle)

    if (!window.ResizeObserver) return

    var pending = false
    var ro = new ResizeObserver(function(){
        if (pending) return
        pending = true
        requestAnimationFrame(function(){
            pending = false
            refresh_puzzle()
        })
    })

    var roots = document.querySelectorAll(".coffee, .spoilers, .puzzle")
    if (!roots.length) ro.observe(puzzle_section)
    for (var i = 0; i < roots.length; i++) ro.observe(roots[i])

}


// iOS Safari never paints a scrubbed mp4 it has to pull with Range requests,
// and it ignores preload until something calls play(). Download the whole
// file, retag it as video/mp4 (Shopify often serves these as octet-stream),
// and hand the element a local blob. One muted play/pause wakes the decoder;
// after that, currentTime scrubs.
function load_scrub_video(video, url){

    var sources = video.querySelectorAll("source")
    for (var i = 0; i < sources.length; i++) sources[i].remove()

    video.muted = true
    video.defaultMuted = true
    video.playsInline = true
    video.setAttribute("muted", "")
    video.setAttribute("playsinline", "")
    video.setAttribute("webkit-playsinline", "")
    video.autoplay = true
    video.setAttribute("autoplay", "")
    video.preload = "auto"
    video.loop = false

    return fetch(url, { mode: "cors" }).then(function(res){
        if (!res.ok) throw new Error("Video download failed: " + res.status)
        return res.blob()
    }).then(function(blob){
        if (!blob.type || blob.type.indexOf("video") === -1) {
            blob = blob.slice(0, blob.size, "video/mp4")
        }

        var local_url = URL.createObjectURL(blob)

        return new Promise(function(resolve, reject){
            var settled = false
            function finish(){
                if (settled) return
                settled = true
                video.pause()
                resolve()
            }
            function fail(err){
                if (settled) return
                settled = true
                reject(err)
            }
            // Pause on the first frame (same as the working retailers clip).
            // play() has to be called too: iOS ignores preload and will not
            // fire loadeddata until something starts playback.
            video.addEventListener("loadeddata", finish, { once: true })
            video.addEventListener("error", function(){
                fail(new Error("Video decode failed"))
            }, { once: true })
            video.src = local_url
            var play_promise
            try { play_promise = video.play() } catch (err) { play_promise = null }
            if (play_promise && typeof play_promise.catch === "function") {
                play_promise.catch(function(){})
            }
        })
    })

}

function can_scrub(video){
    return video.readyState >= 2 && isFinite(video.duration) && video.duration > 0
}


// PHASE 1 (el -0.05 -> 0.30): scrub the background video with scroll.
// Starts a beat before the section pins, then takes a long stretch of
// scroll so the scrub feels slow.
function setup_puzzle_video(puzzle_section){

    var puzzle_video = puzzle_section.querySelector(".background video")
    if (!puzzle_video) return

    var seeking = false
    var last_prog = 0
    var pending_prog = null
    var seek_timer = null
    var media_ready = false

    function flushPending(){
        seeking = false
        if (pending_prog == null) return
        var next = pending_prog
        pending_prog = null
        seekProgress(next)
    }

    function seekProgress(prog){
        last_prog = prog
        if (!media_ready || !can_scrub(puzzle_video)) {
            pending_prog = prog
            return
        }
        var time = (prog / 100) * puzzle_video.duration
        // Stay off the exact end so iOS doesn't fire "ended" and ignore later seeks.
        time = Math.min(time, Math.max(0, puzzle_video.duration - 0.04))
        if (seeking) {
            pending_prog = prog
            return
        }
        if (Math.abs(puzzle_video.currentTime - time) < 0.04) {
            pending_prog = null
            return
        }
        pending_prog = null
        seeking = true
        puzzle_video.currentTime = time
        // Safari sometimes skips the seeked event; don't stay locked
        clearTimeout(seek_timer)
        seek_timer = setTimeout(flushPending, 120)
    }

    puzzle_video.addEventListener("seeked", function(){
        clearTimeout(seek_timer)
        flushPending()
    })

    function onVideoReady(){
        puzzle_video.pause()
        seekProgress(last_prog)
    }

    var puzzle_src = puzzle_video.getAttribute("data-src")
    if (puzzle_src) {
        load_scrub_video(puzzle_video, puzzle_src).then(function(){
            media_ready = true
            onVideoReady()
        }).catch(function(){
            puzzle_video.src = puzzle_src
            puzzle_video.addEventListener("loadeddata", function(){
                media_ready = true
                onVideoReady()
            }, { once: true })
        })
    }

    add_pinned_scroller({
        id: "puzzle-scrub",
        container: puzzle_section,
        window_offset: 0,
        el_start: -0.15,
        el_end: 0.30,
        onunstart: function(){ seekProgress(0) },
        oncomplete: function(){ seekProgress(100) },
        onprogress: function(prog){ seekProgress(prog) }
    })

}


// Full-bleed image slider in the flowing layer. Multiple slides stay
// on screen; swipe is optional and does not pin or hijack vertical scroll.
function setup_puzzle_slider(puzzle_section){

    var el = puzzle_section.querySelector(".puzzle-slider")
    if (!el) return

    new Swiper(el, {
        speed: 500,
        grabCursor: true,
        watchOverflow: true,
        slidesPerView: 1.35,
        spaceBetween: 12,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        threshold: 8,
        touchAngle: 30,
        touchReleaseOnEdges: true,
        navigation: {
            nextEl: el.querySelector(".swiper-button-next"),
            prevEl: el.querySelector(".swiper-button-prev")
        },
        breakpoints: {
            700: {
                slidesPerView: 2.2,
                spaceBetween: 16,
                slidesOffsetBefore: 24,
                slidesOffsetAfter: 24
            },
            1100: {
                slidesPerView: 2.55,
                spaceBetween: 20,
                slidesOffsetBefore: 32,
                slidesOffsetAfter: 32
            }
        }
    })

}


// PHASE 2 (el 0.31 -> 0.41): the full-screen banner shrinks into the gameboy.
// The gameboy starts scaled + translated so its screen covers the viewport,
// then eases down to its natural centered size. Progress comes only from
// scrolltied — no parallel scrollY math.
function setup_gameboy_shrink(puzzle_section){

    var inner = puzzle_section.querySelector(".sticky-inner")
    var gameboy = puzzle_section.querySelector(".gameboy")
    var screen = puzzle_section.querySelector(".gameboy-screen")
    var body = gameboy.querySelector(".gameboy-body")

    var geo = null
    var last_p = 0
    var shrink_start = 0.31
    var shrink_end = 0.41

    function measure(){
        // Measure at natural size (transform removed), relative to the
        // sticky inner, which is exactly viewport-sized while pinned
        var prev = gameboy.style.transform
        gameboy.style.transform = "none"

        var inner_rect = inner.getBoundingClientRect()
        var screen_rect = screen.getBoundingClientRect()

        if (screen_rect.width < 1 || screen_rect.height < 1) {
            geo = null
            gameboy.style.transform = prev
            return
        }

        var screen_cx = (screen_rect.left + screen_rect.width / 2) - inner_rect.left
        var screen_cy = (screen_rect.top + screen_rect.height / 2) - inner_rect.top

        geo = {
            tx: (inner_rect.width / 2) - screen_cx,
            ty: (inner_rect.height / 2) - screen_cy,
            scale: Math.max(inner_rect.width / screen_rect.width, inner_rect.height / screen_rect.height)
        }

        gameboy.style.transform = prev
    }

    function apply(p){
        last_p = Math.max(0, Math.min(1, p))
        if (!geo) measure()

        // Image not measured yet — if we're already past the shrink, sit at
        // natural size instead of flashing the full-bleed start pose
        if (!geo) {
            gameboy.style.transform = last_p >= 1 ? "none" : ""
            return
        }

        var s = geo.scale + (1 - geo.scale) * last_p
        var tx = geo.tx * (1 - last_p)
        var ty = geo.ty * (1 - last_p)

        gameboy.style.transform = "translate(" + tx + "px, " + ty + "px) scale(" + s + ")"
    }

    function remeasure_and_apply(){
        measure()
        apply(last_p)
        refresh_puzzle()
    }

    measure()

    window.addEventListener("resize", remeasure_and_apply)
    window.addEventListener("pageshow", remeasure_and_apply)

    if (body && !body.complete) {
        body.addEventListener("load", remeasure_and_apply)
    }

    add_pinned_scroller({
        id: "puzzle-gameboy",
        container: puzzle_section,
        window_offset: 0,
        el_start: shrink_start,
        el_end: shrink_end,
        targets: [puzzle_section],
        classes: ["gameboy-mode"],
        stick_class: true,
        onunstart: function(){ apply(0) },
        oncomplete: function(){ apply(1) },
        onprogress: function(prog){ apply(prog / 100) }
    })

}


// PHASE 3: once the gameboy is at rest, blinds-in the left headline
// and keep the handheld sticky while copy on the right scrolls past.
function setup_game_stage(puzzle_section){

    var headline = puzzle_section.querySelector(".game-headline .blinds-text")

    add_pinned_scroller({
        id: "puzzle-copy-mode",
        container: puzzle_section,
        window_offset: 0,
        el_start: 0.47,
        el_end: 0.50,
        targets: [puzzle_section],
        classes: ["copy-mode"],
        stick_class: true
    })

    if (headline) {
        add_pinned_scroller({
            id: "puzzle-blinds",
            container: puzzle_section,
            window_offset: 0,
            el_start: 0.41,
            el_end: 0.45,
            targets: [headline],
            classes: ["visible"],
            stick_class: true
        })
    }

    setup_gameboy_screen_video(puzzle_section)
    setup_gameboy_copy_dim(puzzle_section)

}


// Mobile: fade a dim over the handheld while a copy block overlaps it.
function setup_gameboy_copy_dim(puzzle_section){

    var gameboy = puzzle_section.querySelector(".gameboy")
    var blocks = puzzle_section.querySelectorAll(".game-copy-inner")
    if (!gameboy || !blocks.length) return

    var mobile = window.matchMedia("(max-width: 800px)")

    function update(){
        if (!mobile.matches || !puzzle_section.classList.contains("copy-mode")) {
            puzzle_section.classList.remove("copy-over")
            return
        }

        var gb = gameboy.getBoundingClientRect()
        var over = false

        for (var i = 0; i < blocks.length; i++) {
            var r = blocks[i].getBoundingClientRect()
            if (r.height < 1 || r.width < 1) continue
            if (r.bottom > gb.top + 12 && r.top < gb.bottom - 12) {
                over = true
                break
            }
        }

        puzzle_section.classList.toggle("copy-over", over)
    }

    var scheduled = false
    function queue(){
        if (scheduled) return
        scheduled = true
        requestAnimationFrame(function(){
            scheduled = false
            update()
        })
    }

    // Run after scrolltied applies copy-mode on the same scroll event.
    window.addEventListener("scroll", queue, { passive: true })
    window.addEventListener("resize", queue)
    mobile.addEventListener("change", queue)
    queue()

}


// As soon as the first copy beat is on screen, swap the still for the looping video.
function setup_gameboy_screen_video(puzzle_section){

    var video = puzzle_section.querySelector(".gameboy-screen video")
    if (!video) return

    var should_play = false

    function playScreen(){
        should_play = true
        var play = video.play()
        if (play && play.catch) play.catch(function(){})
    }

    function resetScreen(){
        should_play = false
        video.pause()
        video.classList.remove("is-playing")
        if (video.readyState >= 1) video.currentTime = 0
    }

    video.addEventListener("playing", function(){
        if (should_play) video.classList.add("is-playing")
    })

    video.addEventListener("pause", function(){
        if (should_play) playScreen()
    })

    add_pinned_scroller({
        id: "puzzle-screen-video",
        container: puzzle_section,
        window_offset: 0,
        el_start: 0.47,
        el_end: 0.50,
        targets: [puzzle_section],
        classes: ["screen-video"],
        stick_class: true,
        onstart: playScreen,
        oncomplete: playScreen,
        onunstart: resetScreen
    })

}


// PIXEL IMAGES: each .blur-trans in the coffee section stacks 4 tiny
// pixelated copies (8/16/32/64px, rendered by pixel-image.liquid) over
// the real image. As the container enters from the bottom of the viewport
// the layers get "hidden" one at a time, coarsest first (de-pixelation).
// As it exits the top they get "visible" back, finest first (re-pixelation).
// Thresholds are fractions of the container's own height, staggered so
// each layer flips in its own narrow band of scroll.
function setup_pixel_images(){

    var containers = document.querySelectorAll(".coffee .blur-trans")
    if (!containers.length) return

    // setup_puzzle owns scrolltied when a .puzzle section exists;
    // create it here only if that didn't happen (must run after setup_puzzle)
    if (!window.scrolltied) window.scrolltied = new ScrollTide({ nomarkers: true })

    var step_size = 0.18
    var band = 0.05
    var in_offset = 0.25
    var out_offset = 0.25

    containers.forEach(function(el, n){

        // DOM order is finest (64px) -> coarsest (8px), so the coarsest
        // layer stacks on top
        var imgs = Array.from(el.getElementsByClassName("blur"))

        // RE-PIXELATE as the image scrolls off the top of the viewport
        imgs.forEach(function(img, i){
            add_pinned_scroller({
                id: "blur-out-" + n + "-" + i,
                container: el,
                window_offset: 0,
                el_start: out_offset + (step_size * i),
                el_end: out_offset + (step_size * i) + band,
                targets: [img],
                classes: ["visible"],
                stick_class: true
            })
        })

        // DE-PIXELATE as the image enters from the bottom of the viewport
        imgs.slice().reverse().forEach(function(img, i){
            add_pinned_scroller({
                id: "blur-in-" + n + "-" + i,
                container: el,
                window_offset: 1,
                el_start: in_offset + (step_size * i),
                el_end: in_offset + (step_size * i) + band,
                targets: [img],
                classes: ["hidden"],
                stick_class: true
            })
        })

    })

    scrolltied.start()
    scrolltied.update()

}


// COFFEE VIDEO
// The sticky clip scrubs directly with scroll through this section.
// Progress is 0 when the section pins to the top of the viewport and 1
// when it releases. A fast scroll keeps only the latest frame queued, so
// an in-flight seek can't stall the playhead behind the page.
function setup_coffee_video(){

    var section = document.querySelector(".coffee")
    if (!section) return

    var video = section.querySelector(".sticky-media video")
    if (!video) return

    var seeking = false
    var pending = null
    var seek_timer = null
    var queued = false
    var media_ready = false

    function frame_for_scroll(){
        if (!media_ready || !can_scrub(video)) return null
        var scrollable = section.offsetHeight - window.innerHeight
        // The mobile pin is a short bar over a long section, so the clip
        // reaches its last frame before the section releases.
        if (window.matchMedia("(max-width: 800px)").matches) scrollable *= 0.25
        var progress = 0
        if (scrollable > 0) {
            var scrolled = (window.scrollY || window.pageYOffset || 0) - document_top(section)
            progress = scrolled / scrollable
            if (progress < 0) progress = 0
            if (progress > 1) progress = 1
        }
        // Stay a hair off the exact end so the element doesn't fire "ended"
        // and refuse later seeks.
        return Math.min(progress * video.duration, Math.max(0, video.duration - 0.04))
    }

    function seek_to(time){
        if (time == null || !media_ready || !can_scrub(video)) return
        if (seeking) {
            pending = time
            return
        }
        if (Math.abs(video.currentTime - time) < 0.03) {
            pending = null
            return
        }
        seeking = true
        pending = null
        try {
            video.currentTime = time
        } catch (err) {
            seeking = false
            return
        }
        clearTimeout(seek_timer)
        // Safari sometimes skips seeked and would leave the queue locked.
        seek_timer = setTimeout(function(){
            if (!seeking) return
            seeking = false
            if (pending == null) return
            var next = pending
            pending = null
            seek_to(next)
        }, 180)
    }

    video.addEventListener("seeked", function(){
        clearTimeout(seek_timer)
        seeking = false
        if (pending == null) return
        var next = pending
        pending = null
        seek_to(next)
    })

    function sync(){
        if (!media_ready) return
        if (!video.paused) video.pause()
        seek_to(frame_for_scroll())
    }

    function on_scroll(){
        if (queued) return
        queued = true
        var raf = requestAnimationFrame(flush)
        var timer = setTimeout(flush, 32)
        function flush(){
            if (!queued) return
            queued = false
            cancelAnimationFrame(raf)
            clearTimeout(timer)
            sync()
        }
    }

    window.addEventListener("scroll", on_scroll, { passive: true })
    window.addEventListener("resize", on_scroll)
    window.addEventListener("load", on_scroll)
    window.addEventListener("pageshow", on_scroll)

    if (window.ResizeObserver) {
        new ResizeObserver(on_scroll).observe(section)
    }

    var coffee_src = window.matchMedia("(max-width: 800px)").matches
        ? video.getAttribute("data-src-mobile")
        : video.getAttribute("data-src")
    if (!coffee_src) coffee_src = video.getAttribute("data-src")

    if (coffee_src) {
        load_scrub_video(video, coffee_src).then(function(){
            media_ready = true
            sync()
        }).catch(function(){
            video.src = coffee_src
            video.addEventListener("loadeddata", function(){
                video.pause()
                media_ready = true
                sync()
            }, { once: true })
        })
    }

}


// Hash links to #hero, #coffee, #spoilers, #puzzle, #game, and #faq.
// Images above a target load after the first paint and shove it down,
// so keep correcting until the visitor scrolls on their own.
function setup_deeplinks(){

    var user_moved = false

    function hash_target(){
        var hash = (location.hash || "").split("?")[0]
        if (!hash || hash === "#") return null
        var id = ""
        try { id = decodeURIComponent(hash.slice(1)) } catch (err) { return null }
        if (!id || !/^[A-Za-z][\w-]*$/.test(id)) return null
        return document.getElementById(id)
    }

    function scroll_to_game(el){
        var puzzle = el.closest(".puzzle")
        var title = el.querySelector("h3")
        if (!puzzle) {
            el.scrollIntoView({ block: "start" })
            return
        }
        // copy-mode (and the headline) finishes at 50% of the puzzle.
        // The first title sits in the middle of a tall lead-in, so keep
        // going until that heading is centered too.
        var shown = document_top(puzzle) + puzzle.scrollHeight * 0.5
        var centered = shown
        if (title) {
            centered = document_top(title) + title.offsetHeight / 2 - window.innerHeight / 2
        }
        window.scrollTo(0, Math.max(shown, centered))
    }

    function scroll_to_hash(){
        if (user_moved) return
        var el = hash_target()
        if (!el) return
        if (el.id === "game") {
            scroll_to_game(el)
            return
        }
        el.scrollIntoView({ block: "start" })
    }

    function mark_moved(){
        user_moved = true
    }

    window.addEventListener("wheel", mark_moved, { passive: true, once: true })
    window.addEventListener("touchmove", mark_moved, { passive: true, once: true })
    window.addEventListener("keydown", function(e){
        if (e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "PageDown" || e.key === "PageUp" || e.key === " ") mark_moved()
    })

    window.addEventListener("hashchange", function(){
        user_moved = false
        scroll_to_hash()
    })

    if (!hash_target()) return

    scroll_to_hash()
    window.addEventListener("load", scroll_to_hash)
    window.addEventListener("pageshow", scroll_to_hash)

    if (window.ResizeObserver) {
        var ro = new ResizeObserver(scroll_to_hash)
        var roots = document.querySelectorAll(".hero, .coffee, .spoilers, .puzzle, .faq")
        for (var i = 0; i < roots.length; i++) ro.observe(roots[i])
        window.addEventListener("load", function(){
            setTimeout(function(){
                ro.disconnect()
                scroll_to_hash()
            }, 600)
        })
    }

}


function setup_swipers(){

    // TESTIMONIALS: continuous marquee
    const testes_swiper = new Swiper('.testes .swiper', {
        direction: 'horizontal',
        loop: true,
        autoplay: {
            delay: 0,
        },
        spaceBetween: 30,
        slidesPerView: 'auto',
        speed: 8000,
        breakpoints: {
            980: {
                spaceBetween: 50,
                slidesPerView: 2.2,
            }
        }
    });

}


function setup_sticky_atc(){

    var wrap = document.querySelector(".sticky-cta")
    if (!wrap) return

    var qty_el = wrap.querySelector(".qty-val")
    var price_el = wrap.querySelector(".atc-price")
    var current_el = price_el && price_el.querySelector(".atc-current")
    var compare_el = price_el && price_el.querySelector(".atc-compare")
    var label_el = wrap.querySelector(".atc-label")
    var btn = wrap.querySelector(".button.atc")
    if (!qty_el || !price_el || !label_el || !btn) return

    var unit = parseInt(price_el.getAttribute("data-unit-price-cents"), 10)
    var compare_unit = parseInt(price_el.getAttribute("data-compare-cents"), 10)
    var variant_id = parseInt(btn.getAttribute("data-variant-id"), 10)
    var symbol = price_el.getAttribute("data-currency") || "$"
    var clicks = 0
    var errored = false
    var idle_label = "Add to Cart"

    function pretty_price(cents){
        var dollars = cents / 100
        return dollars % 1 !== 0 ? dollars.toFixed(2) : String(Math.round(dollars))
    }

    function qty(){
        var n = parseInt(qty_el.textContent, 10)
        return isNaN(n) || n < 1 ? 1 : n
    }

    function render_price(){
        var q = qty()
        var current = symbol + pretty_price(unit * q)
        if (current_el) current_el.textContent = current
        else price_el.textContent = current

        if (!compare_el) return
        if (compare_unit > unit) {
            compare_el.hidden = false
            compare_el.textContent = symbol + pretty_price(compare_unit * q)
        } else {
            compare_el.hidden = true
        }
    }

    wrap.querySelector(".qty-up").addEventListener("click", function(){
        qty_el.textContent = qty() + 1
        render_price()
    })

    wrap.querySelector(".qty-down").addEventListener("click", function(){
        qty_el.textContent = Math.max(1, qty() - 1)
        render_price()
    })

    function restore_label(){
        label_el.textContent = idle_label
    }

    btn.addEventListener("click", function(){
        if (btn.classList.contains("disabled") || typeof CartJS === "undefined") return

        clicks++
        label_el.textContent = "Going..."

        CartJS.addItem(variant_id, qty(), {}, {
            success: function(line_item){
                if (typeof show_cart_confirm === "function") show_cart_confirm(line_item)
                $("header .cart-count").show()
                label_el.textContent = clicks > 1 ? "Again, again!!" : "You did it!"
                setTimeout(restore_label, 1600)
            },
            error: function(){
                label_el.textContent = errored ? "Please call us..." : "Error! :("
                errored = !errored
                setTimeout(restore_label, 1600)
            }
        })
    })

    $(".hero .text .button").on("click", function(){
        btn.click()
    })

    render_price()

}
